import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../../Assets/Styles/pages/signature.scss";
import React from "react";

const IconsRow = ({ icon, onClick, text }) => {
  const { t } = useTranslation();
  return (
    <Row
      className="rounded_icons mx-2 py-2 m-0 align-items-center justify-content-center d-flex pointer"
      onClick={() => {
        onClick();
      }}
    >
      <Col
        lg={4}
        className="m-0 d-flex flex-column align-items-center mx-Large-2 p-0"
      >
        <img className="icon p-0" src={icon} alt="icon" />
      </Col>
      <Col lg={6} className="m-0 d-flex flex-column align-items-start p-0">
        {t(text)}
      </Col>
    </Row>
  );
};

export default IconsRow;
